import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

import App from './App';
import './index.css';

ReactDOM.render(<App />, document.getElementById('trueid-app-root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js